/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Event_Groups_LabelInputs */



/**
* | output |
* | --- |
* | "Event Groups" |
*
* @param {Team_Share_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_event_groups_label = /** @type {((inputs?: Team_Share_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupos de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupos de eventos")
	return /** @type {LocalizedString} */ ("Event Groups")
});